

(function($, App, Utils, Components) {
  'use strict';

  var logger = new Logger("DataShow");

  Components.create("DataShow", {


    bindEvents: function() {
      Utils.Ajax.on(Utils.Ajax.Events.Success, function() {
        Components.DataShow.bindTogglers();
      });

      Utils.Responsive.on(Utils.Responsive.Events.ResolutionEnter, function(e, res) {
        Components.DataShow.bindTogglers();
      });
    },

    bindTogglers: function() {
      $('*[data-show]').not('[data-show=""]').off('click.data-show deselect.data-show').on('click.data-show deselect.data-show', function(e) {

        // This will prevent double events
        if ($(e.target).is("label")) {
          return true;
        }

        var
          self           = $(this),
          tSelector      = self.data('show'),
          disable        = self.data('showEnable'),

          hSelector      = self.data('hide'),
          hiddenClass    = self.data('hideClass') || 'hidden',
          cssClass       = self.data('toggleClass') || 'in',
          selfClass      = self.data('selfClass') || 'active',
          shownLabel     = self.data('shownLabel'),
          hiddenLabel    = self.data('hiddenLabel'),
          labelContainer = self.data('labelElement'),
          closest        = self.data('parent'),
          slide          = self.data('slide'),
          slideDown      = self.data('down'),
          context        = self.data('context'),
          parent         = closest ? self.closest(closest) : self,
          target         = closest && (tSelector.match('^#') == null) ? parent.find(tSelector) : $(tSelector),
          hide           = hSelector ? (closest && (hSelector.match('^#') == null) ? parent.find(hSelector) : $(hSelector)) : false,
          remoteUrl      = target.data('remote'),
          switchControl  = self.find('input[type="radio"], input[type="checkbox"]'),
          showEvent      = self.data('showEvent'),
          wasVisible     = target.is(':visible');

        slide = typeof slide != 'undefined' ? slide : true;

        if (context) {
          if (target.length == 0) {
            target = $(context).find(tSelector);
          }

          if (hide.length == 0) {
            hide = $(context).find(hSelector);
          }
        }

        if (disable) {
          var resolutions = disable.split(',');
          if ($.inArray(Utils.Responsive.getCurrentResolution().label, resolutions) > -1) {
            self.off('click.data-show deselect.data-show');
            target.css('display', '');
            return true;
          }
        }

        var toggle = !target.hasClass(cssClass);

        if (switchControl.length != 0 && !switchControl.is(':disabled')) {
          toggle =  switchControl.is(':checked');
        }

        if (slide) {
          target.slideToggle();
        }

        if (slideDown) {
          target.slideDown();
        }

        if (selfClass) {
          logger.d(`Toggling ${cssClass} on target and on parent:`, target, parent);
          target.toggleClass(cssClass, toggle);
          parent.toggleClass(selfClass, toggle);

        } else {
          logger.d(`Toggling ${cssClass} on parent:`, parent);
          parent.toggleClass(cssClass);

        }

        if (remoteUrl && (target.is(':empty') || target.find('> .loading').length != 0)) {
          target.load(remoteUrl).append(body);
        }

        if (hide) {
          logger.d("Hiding", hide);
          hide.addClass(hiddenClass);
        }

        if (showEvent) {
          logger.d('Emitting', showEvent);
          self.trigger(showEvent);
        }

        if (labelContainer) {
          labelContainer = self.find(labelContainer);
        } else {
          labelContainer = self;
        }

        if (shownLabel && !wasVisible) {
          labelContainer.text(shownLabel);
        }

        if (hiddenLabel && wasVisible) {
          labelContainer.text(hiddenLabel);
        }

      });
    },

    init: function() {
      Components.DataShow.bindEvents();
      Components.DataShow.bindTogglers();
    }

  });

})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components
);